import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import bkgs from '#utilities/js/rte/bkgs/bkgs.js'
import paragraph from '#utilities/js/rte/paragraph/paragraph.js'
import smileys from '#utilities/js/rte/smileys/smileys.js'
import specials from '#utilities/js/rte/specials/specials.js'
import style from '#utilities/js/rte/style/style.js'
import command from '#utilities/js/rte/command/command.js'
import iframe from './iframe.js'
import iframeFocusOut from './iframeFocusOut.js'
import actions from "./actions.js";
import advanced_actions from "./advanced_actions.js";

export default contract({
  bkgs,
  command,
  paragraph,
  smileys,
  specials,
  style,
  actions: array([
    actions
  ]),
  advanced_actions: array([
    advanced_actions
  ]),
  iframe: array([
    iframe
  ]),
  iframeFocusOut: array([
    iframeFocusOut
  ]),
})